export const CARDSPATH = "/cards/";
export const CARDBACK = CARDSPATH + "Gefuehlsmonster_Scan_Deckblatt-2019.png";

export const Cards = [
    {id: 1, img: 'Gefuehlsmonster_Scan_2020-1.png'},
    {id: 2, img: 'Gefuehlsmonster_Scan_2020-2.png'},
    {id: 3, img: 'Gefuehlsmonster_Scan_2020-3.png'},
    {id: 4, img: 'Gefuehlsmonster_Scan_2020-4.png'},
    {id: 5, img: 'Gefuehlsmonster_Scan_2020-5.png'},
    {id: 6, img: 'Gefuehlsmonster_Scan_2020-6.png'},
    {id: 7, img: 'Gefuehlsmonster_Scan_2020-7.png'},
    {id: 8, img: 'Gefuehlsmonster_Scan_2020-8.png'},
    {id: 9, img: 'Gefuehlsmonster_Scan_2020-9.png'},
    {id: 10, img: 'Gefuehlsmonster_Scan_2020-10.png'},
    {id: 11, img: 'Gefuehlsmonster_Scan_2020-11.png'},
    {id: 12, img: 'Gefuehlsmonster_Scan_2020-12.png'},
    {id: 13, img: 'Gefuehlsmonster_Scan_2020-13.png'},
    {id: 14, img: 'Gefuehlsmonster_Scan_2020-14.png'},
    {id: 15, img: 'Gefuehlsmonster_Scan_2020-15.png'},
    {id: 16, img: 'Gefuehlsmonster_Scan_2020-16.png'},
    {id: 17, img: 'Gefuehlsmonster_Scan_2020-17.png'},
    {id: 18, img: 'Gefuehlsmonster_Scan_2020-18.png'},
    {id: 19, img: 'Gefuehlsmonster_Scan_2020-19.png'},
    {id: 20, img: 'Gefuehlsmonster_Scan_2020-20.png'},
    {id: 21, img: 'Gefuehlsmonster_Scan_2020-21.png'},
    {id: 22, img: 'Gefuehlsmonster_Scan_2020-22.png'},
    {id: 23, img: 'Gefuehlsmonster_Scan_2020-23.png'},
    {id: 24, img: 'Gefuehlsmonster_Scan_2020-24.png'},
    {id: 25, img: 'Gefuehlsmonster_Scan_2020-25.png'},
];